/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InterruptionCountOut } from './interruptionCountOut';

export interface ParticipantMetricsOut {
  participant_id: string;
  display_name: string | null;
  role: string;
  is_member: boolean;
  minutes_late: number | null;
  sessions_count: number;
  time_absent_s: number;
  speech_withheld: boolean;
  talk_time_s: number | null;
  talk_share: number | null;
  words_per_minute: number | null;
  longest_stretch_s: number | null;
  interruptions_made: number | null;
  interruptions_received: number | null;
  interrupted: InterruptionCountOut[] | null;
}
